function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13132",
  width: 40,
  height: 40,
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_68151",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_146498",
  d: "M6.068,8.157H29.686a1.147,1.147,0,0,0,1.143-1.143,1.128,1.128,0,0,0-1.143-1.13H6.068a1.117,1.117,0,0,0-1.13,1.13A1.136,1.136,0,0,0,6.068,8.157Zm.5,7.584H29.2a1.437,1.437,0,0,0,1.632-1.607v-1.08A1.442,1.442,0,0,0,29.2,11.447H6.571a1.442,1.442,0,0,0-1.632,1.607v1.08A1.437,1.437,0,0,0,6.571,15.741Zm0,6.579h9.392a1.433,1.433,0,0,0,1.62-1.607v-1.08a1.434,1.434,0,0,0-1.62-1.595H6.571a1.438,1.438,0,0,0-1.632,1.595v1.08A1.437,1.437,0,0,0,6.571,22.32Zm14-1h9.115a1.147,1.147,0,0,0,1.143-1.143,1.128,1.128,0,0,0-1.143-1.13H20.571a1.136,1.136,0,0,0,0,2.273ZM6.068,27.9H29.686a1.147,1.147,0,0,0,1.143-1.143,1.128,1.128,0,0,0-1.143-1.13H6.068a1.117,1.117,0,0,0-1.13,1.13A1.136,1.136,0,0,0,6.068,27.9Z",
  transform: "translate(2.116 2.522)"
}));

function SvgMessageContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageContent);
export default __webpack_public_path__ + "static/media/message-content.2094db58.svg";
export { ForwardRef as ReactComponent };